import { Box, Flex } from "@acko-tech/building-blocks.ui.common";
import styled from "styled-components";

export const CheckoutCardWrapper = styled.div`
  box-shadow: 0px 4px 12px rgba(61, 57, 82, 0.08);
  display: flex;
  flex-direction: column;
  background: #fff;
  padding: 0 16px
`;

export const CarDetailsContainer = styled(Flex)`
  align-items: center;
  padding: 16px;
  gap: 12px;
`;

export const PolicyStartDate = styled(Flex)`
  color: #5b5675;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  span {
    font-weight: 500;
    color: #040222;
  }
  padding-left: 16px
`;